import React from 'react';

import { getAppConfig } from '@services/config';

type EnergyLabelProps = {
    rating?: string;
    onClick?: () => void;
    className?: string;
};

export function EnergyLabel({ rating, onClick, className }: Readonly<EnergyLabelProps>) {
    if (!rating) return null;

    const imgElement = (
        <img
            className={className}
            src={`${getAppConfig().assets.cmsImages.url}/original/image/CMS/ecommerce/energy-label/${rating.toLowerCase()}.svg`}
            alt={`Classe énergétique : ${rating}`}
            width={80}
            loading='lazy'
        />
    );

    if (!onClick) {
        return imgElement;
    }

    return (
        <button onClick={onClick} className='button-clear' aria-label="Voir l'étiquette énergétique">
            {imgElement}
        </button>
    );
}
